import Vue from 'vue'



import App from './App.vue'

import * as echarts from 'echarts'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'


import '@/assets/css/transition.scss'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Popper from 'element-ui/src/utils/vue-popper'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'
import router from './router'
import store from './utils/store'

import axios from 'axios'


import '../mock/mock.js'

import VueAnimateNumber from "vue-animate-number";
Vue.use(VueAnimateNumber);

Vue.use(ElementUI, { locale })

axios.defaults.withCredentials=true
Vue.prototype.$axios = axios



Vue.use(Popper)
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.config.productionTip = false

Vue.prototype.$echarts = echarts





new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
